import { api } from './client';

export const produtosApi = {
  listar: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return api.get(`/produtos${qs ? `?${qs}` : ''}`);
  },
  obter: (id) => api.get(`/produtos/${id}`),
  criar: (dados) => api.post('/produtos', dados),
  atualizar: (id, dados) => api.put(`/produtos/${id}`, dados),
  remover: (id) => api.del(`/produtos/${id}`),
  obterPrecosCustos: (id) => api.get(`/produtos/${id}/precos-custos`),
  salvarPrecosCustos: (id, dados) => api.put(`/produtos/${id}/precos-custos`, dados)
};

export const categoriasApi = {
  listar: () => api.get('/produtos-categorias'),
  criar: (dados) => api.post('/produtos-categorias', dados)
};
